//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectContractById, approveContract } from "@/api/contract/contract";
import { BASIC, JPT_URL } from "@/config/constant"
import { Toast } from 'mint-ui';
export default {
	name: "humanDayoutDetail",
	data() {
		return {
			contract: {},
			approve: false,
			trunDialog: false,
			passDialog: false,
			trunMessage: '',
			passMessage: '',
			businessKey: this.$route.query.cid,
			contCateCode: this.$route.query.contCateCode,
			contTypeCode: this.$route.query.contTypeCode,
			gobackName: this.$route.query.gobackName,
			taskParam: {},
			appParams: {},
		}
	},
	created() {
		if (this.$route.query.taskParam != undefined) {
			this.taskParam = this.$route.query.taskParam;
			if (this.$route.query.taskParam.taskType == 'undo') {
				this.approve = true;
				this.appParams.taskDefinitionKey = this.$route.query.taskParam.taskDefinitionKey;
				this.appParams.taskId = this.$route.query.taskParam.taskId;
			}
		}
		var data = {
			'contractId': this.$route.query.cid
		};
		selectContractById(data).then(response => {
			this.contract = response;
		});
	},
	methods: {
		/******文件预览start***************/
		preview(fileId) {
			var url = JPT_URL + BASIC + "/doc/preview?docId=" + fileId;
			this.JX_download(url);
		},

		// 下载最新版本
		JX_download(url) {
			plus.nativeUI.showWaiting("下载中...");
			//创建下载管理对象
			var SX_down = plus.downloader.createDownload(url, {}, function (d, status) {
				// 下载完成
				if (status == 200) {
					plus.nativeUI.closeWaiting();
					//下载成功后的回调函数
					// plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
					plus.runtime.openFile(d.filename, {}, function (e) { //调用第三方应用打开文件
						plus.nativeUI.toast('打开失败');
					});

				} else {
					plus.nativeUI.closeWaiting();
					plus.nativeUI.toast('下载失败');
				}
			});
			SX_down.start();
		},
		/******文件预览end***************/
		returnList() {
			if (this.$route.query.taskParam != undefined) {
				this.$router.go(-2);
			} else {
				this.$router.push({
					name: '合同列表',
					params: {
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
		},
		trunDownClk() {
			this.trunDialog = true;
		},
		passClk() {
			this.passDialog = true;
		},
		cancelButton() {
			this.trunDialog = false;
			this.passDialog = false;
			this.trunMessage = '';
			this.passMessage = '';
		},
		//驳回提交
		turnDownSubmit() {
			this.appParams.id = this.contract.id;
			this.appParams.status = 'E';
			this.appParams.msg = this.trunMessage;
			this.approveCont();

		},
		//通过提交
		passSubmit() {
			this.appParams.id = this.contract.id;
			this.appParams.status = 'S';
			this.appParams.msg = this.passMessage;
			this.approveCont();
		},
		approveCont() {
			var data = {
				appParams: JSON.stringify(this.appParams)
			};
			approveContract(data).then(response => {
				if (response) {
					Toast({
						message: '操作成功！',
						position: 'top',
						duration: 1500,
						className: "success"
					});
					this.$router.push({
						path: "/"
					});
				} else {
					Toast({
						message: '请求错误！',
						position: 'top',
						duration: 1500,
						className: "error"
					});
				}
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/view/contract/detail/humanDayoutDetail.vue